module.exports = __webpack_public_path__ + "img/EvenTougher.399640b2.png";